import { useState } from "react";
import { useTranslate, IResourceComponentsProps } from "@pankod/refine-core";
import {
  Create,
  Form,
  Input,
  useForm,
} from "@pankod/refine-antd";
import { Modal, Typography, Button } from "antd";

import { IServiceAccount } from "interfaces";

const { Text, Paragraph } = Typography;

export const ServiceAccountCreate: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const [secretModalVisible, setSecretModalVisible] = useState(false);
  const [createdSecret, setCreatedSecret] = useState("");
  const [createdClientId, setCreatedClientId] = useState("");

  const { formProps, saveButtonProps } = useForm<IServiceAccount>({
    redirect: false,
    onMutationSuccess: (data) => {
      const record = data?.data;
      if (record?.client_secret) {
        setCreatedClientId(record.client_id);
        setCreatedSecret(record.client_secret);
        setSecretModalVisible(true);
      }
    },
  });

  return (
    <>
      <Create saveButtonProps={saveButtonProps}>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label={t("serviceAccount.fields.name")}
            name="name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Create>

      <Modal
        title={t("serviceAccount.secret.title", "Service Account Created")}
        visible={secretModalVisible}
        closable={false}
        footer={[
          <Button
            key="ok"
            type="primary"
            href="/service-account"
          >
            {t("serviceAccount.secret.ok", "I've saved the credentials")}
          </Button>,
        ]}
      >
        <Paragraph>
          <Text strong>
            {t(
              "serviceAccount.secret.warning",
              "Save these credentials now. The client secret will not be shown again."
            )}
          </Text>
        </Paragraph>
        <Paragraph>
          <Text>{t("serviceAccount.fields.client_id", "Client ID")}: </Text>
          <Text code copyable>{createdClientId}</Text>
        </Paragraph>
        <Paragraph>
          <Text>{t("serviceAccount.fields.client_secret", "Client Secret")}: </Text>
          <Text code copyable>{createdSecret}</Text>
        </Paragraph>
      </Modal>
    </>
  );
};
